export const USER_CONSTANTS = {
  LOGIN: "LOGIN",
  PROFILE_DATA: "PROFILE_DATA",
  DEFAULT_PIC_URL: "930ac0fc-20a3-4825-8cd5-eb71c134f3e0.png",
  CREATE_USER: "CREATE_USER",
  UPDATE_USER: "UPDATE_USER",
  GET_USERS: "GET_USERS",
  GET_USER_BY_ID: "GET_USER_BY_ID",
  DELETE_USER: "DELETE_USER",
  GET_USERS_LIST: "GET_USERS_LIST",
  GET_PERMISSIONS: "GET_PERMISSIONS",
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  GET_NOTIFICATIONS_BY_ID : "GET_NOTIFICATIONS_BY_ID",
  GET_LOCATIONS: "GET_LOCATIONS"
};
